import React, {useEffect} from "react";
import {
    Form, Button, Container, Row, Col, Card, Navbar, Offcanvas,
} from "react-bootstrap";
import "./LaborerMaster.css";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import Modal from "react-bootstrap/Modal";
import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import CheckInimg from "../../../images/CheckInimg.png";
import {useRef} from "react";
//import { BlobServiceClient, ContainerClient } from "@azure/storage-blob";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "../../util/Axios/AxiosInstance";
import {toast} from 'react-toastify';
import {emptyToNull, normalizeOptionalNumericField} from "./formatIdentifiers";

function LaborerMaster({HandleEvent}) {
    const navigate = useNavigate();
    // const [id, setId] = useState("");
    const [showL, setShowL] = useState(false);
    const [showMsgL, setShowMsgL] = useState("");
    const handleClose = () => setShowL(false);
    const handleBack = (e) => {
        e.preventDefault();
        HandleEvent(2);
    };
    const handleShow = (e) => {
        e.preventDefault();
        setShowL(true);
    };
    const [showUploadDocsModal, setShowUploadDocsModal] = useState(false);
    const uploadDocshandleClose = () => setShowUploadDocsModal(false);
    const uploadDocshandleShow = () => setShowUploadDocsModal(true);
    //const showSuccessMsgL = () => setShowMsgL(true);

    const [branch, setBranch] = useState(localStorage.getItem("branch"));
    const [branchId, setBranchId] = useState(localStorage.getItem("branchId"));
    const [contractName, setContractName] = useState(localStorage.getItem("contractName"));
    const [vendorId, setVendorId] = useState(localStorage.getItem("vendorId") ? localStorage.getItem("vendorId") : "");
    const [vendorName, setVendorName] = useState(localStorage.getItem("vendorName") ? localStorage.getItem("vendorName") : "");
    const [labourId, setLabourId] = useState("");
    const [labourName, setLabourName] = useState("");
    const [addImage, setAddImage] = useState("");
    const [labourDob, setLabourDob] = useState("");
    const [labourBloodGroup, setLabourBloodGroup] = useState("");
    const [labourdoj, setLabourDoj] = useState("");
    const [gender, setGender] = useState("");
    const [designation, setDesignation] = useState("");
    const [educationalQualification, setEducationalQualification] = useState("");
    const [aadharNo, setAadharNo] = useState("");
    const [manpower, setManpower] = useState("");
    const [address, setAddress] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [altNumber, setAltNumber] = useState("");
    const [email, setEmail] = useState("");
    const [altEmail, setAltEmail] = useState("");
    const [bankState, setBankState] = useState("");
    const [bankName, setBankName] = useState("");
    const [accountNo, setAccountNo] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [branchName, setBranchName] = useState(localStorage.getItem('branch'));
    // const [mailId, setMailId] = useState("");
    const [pfEstNo, setPfEstNo] = useState("");
    const [esiNo, setEsiNo] = useState("");
    const [uanNo, setUanNo] = useState("");
    const [migrantWorkers, setMigrantWorkers] = useState("");
    const imageUploadRef = useRef("");
    const imageUploadNameRef = useRef("");
    const [highestQualification, setHighestQualification] = useState("");
    const [qualificationCertificate, setQualificationCertificate] = useState("");
    const [bankPassbook, setBankPassbook] = useState("");
    // const [branchList, setBranchList] = useState([{ 'id': '', 'branchName': '' }]);
    const [vendorList, setVendorList] = useState([{'id': '', 'vendorName': ''}]);
    // const [contractList, setContractList] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [unique,setUnique] = useState(false);

    const [labourAge, setLabourAge] = useState("");
    const [file, setFile] = useState("");
    const [fileName, setFileName] = useState("");

    // New states for documents
    const [aadhaarFile, setAadhaarFile] = useState(null);
    const [aadhaarFileName, setAadhaarFileName] = useState("");
    const [ePehchanFile, setEPehchanFile] = useState(null);
    const [ePehchanFileName, setEPehchanFileName] = useState("");
    const [labourPhotoFile, setLabourPhotoFile] = useState(null);
    // labourPhotoFileName is essentially fileName, but let's keep it consistent if needed. 
    // For now, I'll stick to using 'file' and 'fileName' for Labour Photo to minimize regression, 
    // or I can refactor. Given the existing code uses 'file' and 'fileName' for labourImg, I will keep using them for Labour Photo.

    const onFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.error("Only JPEG and PNG are allowed for Labour Photo");
                return;
            }
            setFile(selectedFile);
            setFileName(selectedFile.name);
            imageUploadRef.current = selectedFile;
            imageUploadNameRef.current = selectedFile.name;
        }
    };

    const onAadhaarFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.error("Only PDF, JPEG, and PNG are allowed for Aadhaar Card");
                return;
            }
            setAadhaarFile(selectedFile);
        }
    };

    const onEPehchanFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.error("Only PDF, JPEG, and PNG are allowed for E-Pehchan Card");
                return;
            }
            setEPehchanFile(selectedFile);
        }
    };

    const uploadDocuments = async () => {
        try {
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                const res = await axios.post("upload", formData);
                setFileName(res.data);
            }
            if (aadhaarFile) {
                const formData = new FormData();
                formData.append("file", aadhaarFile);
                const res = await axios.post("upload", formData);
                setAadhaarFileName(res.data);
            }
            if (ePehchanFile) {
                const formData = new FormData();
                formData.append("file", ePehchanFile);
                const res = await axios.post("upload", formData);
                setEPehchanFileName(res.data);
            }
            toast.success("Documents uploaded successfully (ready to save)");
            uploadDocshandleClose();
        } catch (err) {
            console.error(err);
            toast.error("Error uploading documents");
        }
    };


    const getVendorList = () => {

    }

    // const uploadFile = async () => {

    //     if (imageUploadRef.current) {
    //       const formData = new FormData();
    //       formData.append('file', imageUploadRef.current);
    //       console.log(formData);
    //       // console.log(JSON.stringify(formData));
    //       // return;
    //       const url = 'https://competitorsclaimstorage.blob.core.windows.net/clms/'+imageUploadNameRef.current+'?sp=racwdl&st=2023-07-18T08:55:30Z&se=2023-12-31T16:55:30Z&sv=2022-11-02&sr=c&sig=4PVUHe944BfWZ3v7TyYO0iOrUFGsDvmHjXQ1OUcJX2I%3D';
    //       // const url = 'https://competitorsclaimstorage.blob.core.windows.net/clms/'+fileName+'?sv=2022-11-02&ss=bf&srt=o&sp=wactfx&se=2023-07-07T03:10:25Z&st=2023-06-06T19:10:25Z&spr=https&sig=kOyGC4ClW%2FY3n3dl40G2HqJlDZt4y10WzaY2BByzddU%3D';
    //       const headers = {
    //         'x-ms-blob-type': 'BlockBlob',
    //         'Content-Type' : 'image/jpeg',
    //         // Authorization: 'Bearer <token>',
    //       };
    //       fetch(url, {
    //         method: 'PUT',
    //         body: imageUploadRef.current,
    //         headers: headers
    //       })
    //         .then((response) => {
    //           // Handle response
    //           sucessMessage();
    //         })
    //         .catch((error) => {
    //           // Handle error
    //         });
    //     }
    //   }

    // let storageAccountName = 'competitorsclaimstorage';
    // // let sasToken = 'sp=r&st=2023-05-26T11:27:02Z&se=2023-05-26T19:27:02Z&sv=2022-11-02&sr=c&sig=kF6e8sLMBwqH6Zf8igqcLKfrGqXqTE%2FnAoc0gY1Ites%3D';

    // let sasToken = 'sp=racwdl&st=2023-05-26T13:20:13Z&se=2023-08-04T21:20:13Z&sv=2022-11-02&sr=c&sig=Gomi1WeFGQTboCu7MUKqWuaKwWYwIgKOXHXBnMzrSL0%3D';
    // // const url = `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    // // const url = `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    // const url = 'https://competitorsclaimstorage.blob.core.windows.net/clms/text.txt?sv=2022-11-02&ss=bf&srt=o&sp=wactfx&se=2023-07-07T03:10:25Z&st=2023-06-06T19:10:25Z&spr=https&sig=kOyGC4ClW%2FY3n3dl40G2HqJlDZt4y10WzaY2BByzddU%3D';
    // const blobService = new BlobServiceClient(url);
    //

    // const containerClient = blobService.getContainerClient('clms');
    // await containerClient.createIfNotExists({
    //   access: 'container',
    // });
    // //create blobClient for container
    // const blobClient = containerClient.getBlockBlobClient(file.name);

    // //set mimetype as determined from browser with file upload control
    // const options = { blobHTTPHeaders: { blobContentType: file.type } };

    // //upload file
    // await blobClient.uploadBrowserData(file, options)
    // // // const content = "Hello world!";
    // // const uploadBlobResponse = await blockBlobClient.upload(blobClient, content.length);

    // }

    useEffect(() => {
        AOS.init();
        getVendorMasterDetailsByBranch(branchId);
    }, [])

    const calculate_age = (dob) => {
        var today = new Date();
        var birthDate = new Date(dob);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }

        setLabourAge(age_now);
    };

    const onSelectDOB = (e) => {
        setLabourDob(e.target.value);
        calculate_age(e.target.value);
    };

    let blobImageUpload = async () => {
        // e.preventDefault();
        const formData = new FormData();
        formData.append("file", imageUploadRef.current);
        axios.post("upload", formData)
            .then((data) => {

            });
    };

    let handleSubmit = async (e) => {
        e.preventDefault();
        setUnique(false);
        let addLabourMaster = {
            branchId: branchId,
            branch: branch,
            contractName: contractName,
            vendorName: vendorName,
            labourName: labourName,
            labourDob: labourDob,
            labourId: labourId,
            labourAge: labourAge,
            labourBloodGroup: labourBloodGroup,
            labourDoj: labourdoj,
            gender: gender,
            designation: designation,
            educationalQualification: educationalQualification,
            adhaarNo: normalizeOptionalNumericField(aadharNo),
            manpower: manpower,
            address: emptyToNull(address),
            pinCode: normalizeOptionalNumericField(pinCode),
            contactNumber: emptyToNull(contactNumber),
            altNumber: emptyToNull(altNumber),
            email: emptyToNull(email),
            altEmail: emptyToNull(altEmail),
            bankState: emptyToNull(bankState),
            bankName: emptyToNull(bankName),
            accountNo: normalizeOptionalNumericField(accountNo),
            ifscCode: emptyToNull(ifscCode),
            branchName: emptyToNull(branchName),
            pfEstNo: emptyToNull(pfEstNo),
            esiNo: normalizeOptionalNumericField(esiNo),
            uanNo: normalizeOptionalNumericField(uanNo),
            migrantWorkers: emptyToNull(migrantWorkers),
            highestQualification: emptyToNull(highestQualification),
            qualificationCertificate: emptyToNull(qualificationCertificate),
            bankPassbook: emptyToNull(bankPassbook),
            vendorId: vendorId,
            labourImg: emptyToNull(fileName),
            aadhaarCardImg: emptyToNull(aadhaarFileName),
            ePehchanCardImg: emptyToNull(ePehchanFileName),
        }

        axios.post("addLabourerMasterDetails", addLabourMaster)
            .then((data) => {
                if(data.status === 200) {
                    HandleEvent(2);
                    sucessMessage();
                }
                if (data?.response?.status === 409) {
                    console.log(data?.response?.data?.msg)
                    if (data?.response?.data?.msg) {
                        toast.error(data.response.data.msg)
                        // setUnique(true);
                        window.scrollTo({
                            top: 0, behavior: "smooth",
                        });
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    const handleClickConfirm = (e) => {
        confirmAlert({
            title: <p className="alertTitle">Confirm to submit</p>, message: (<p className="alertMessage">
                Click on Proceed to Save the Labour Details
            </p>), buttons: [{
                label: "Proceed", onClick: () => handleSubmit(e),
            }, {
                label: "Cancel",
            },],
        });
    };

    const errorCheck = async (e) => {
        e.preventDefault();
        if (// fileName.trim().length === 0 ||
            vendorId.trim().length === 0 ||labourName.trim().length === 0 ||labourId.trim().length === 0 || labourAge <= 18 || labourAge >= 80 ||
            (gender != "male" && gender != "female") || labourdoj === "" || labourBloodGroup.trim().length === 0 ||
            designation.trim().length === 0 || educationalQualification.trim().length === 0 ||
            aadharNo.trim().length != 12 || manpower.trim().length === 0
            // || address.trim().length === 0 ||
            // pinCode.length != 6 || !contactNumber.match("[0-9]") || altNumber === contactNumber ||
            // email.length == 0 || altEmail === email || pfEstNo.trim().length === 0 || esiNo.length === 0 ||
            // bankState.trim().length === 0 || bankName.trim().length === 0 || accountNo.length < 5 ||
            // accountNo.length > 18 || ifscCode.trim().length === 0 || branchName.trim().length === 0
        ) {
            setError(true);
            window.scrollTo({
                top: 0, behavior: "smooth",
            });
        } else {
            handleClickConfirm(e);
        }
    };

    const sucessMessage = () => {
        confirmAlert({
            title: <p className="alertTitle">Updated Successfully</p>,
            message: <img src={CheckInimg} className="successImg" alt=""/>,
            buttons: [{
                label: "Close Page",
            },],
        });
        // HandleEvent(2);
    };

    const getVendorMasterDetailsByBranch = (branchId) => {
        axios
            .get("getVendorMasterDetailsByBranchId/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const vendorList = data.data;

                    setVendorList(vendorList);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const onSelectVendorShift = (e) => {
        const selectedOption = e.target.selectedOptions[0];
        setVendorId(e.target.value);
        setVendorName(selectedOption.id);
        setContractName(selectedOption.innerText);
        // setVendorName(e.target.selectedOptions[0].id);
        // let newArr = [...resultArray];
        // newArr[i].vendorId = e.target.value;
        // newArr[i].vendorName = e.target.selectedOptions[0].id;
        // setResultArray(newArr);
        // setDraftData(true);
    };

    return (<div>
        <Container fluid className="px-0">
            <div className="">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor"}>Laborer Master</h5>
                </div>
                {/*<div className="SaveCancelButtonDiv">*/}
                {/*  <div className="container">*/}
                {/*    <div className="row">*/}
                {/*      <div className="text-right">*/}
                {/*        /!* <button type="button" className="btn btn-primary float-end mx-2">Cancel</button> *!/*/}
                {/*        <button onClick={nextPage()} className="btn btn-primary float-end">List Labours</button>*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div data-aos="zoom-in-right" data-aos-duration="450">
                    <Form>
                        <Card className="cardStyl">
                            {/* <div> */}
                            <Navbar bg="white" className="mb-3">
                                <Container fluid className="px-0">
                                    <Navbar.Brand style={{fontWeight: "500"}}>
                                        Personal Information
                                    </Navbar.Brand>
                                    <Navbar.Toggle/>
                                    <Navbar.Offcanvas
                                        id="id2"
                                        aria-labelledby="id1"
                                        placement="end"
                                    >
                                        <Offcanvas.Body>
                                            {/* <Nav className="justify-content-end flex-grow-1 pe-3">
                        <NavDropdown
                          title="Select Branch"
                          id='id1'
                        >
                          <NavDropdown.Item href="#action3">Erode</NavDropdown.Item>
                          <NavDropdown.Item href="#action4">
                            Plant1
                          </NavDropdown.Item>
                          <NavDropdown.Item href="#action5">
                            Plant2
                          </NavDropdown.Item>
                           <NavDropdown.Divider />
                          <NavDropdown.Item href="#action5">
                            Plant2
                          </NavDropdown.Item>
                          <NavDropdown.Divider />
                        </NavDropdown>
                      </Nav> */}
                                        </Offcanvas.Body>
                                    </Navbar.Offcanvas>
                                </Container>
                            </Navbar>
                            <div>
                                {/* <Row className="mb-3">
                  <Col xs={6}>
                    <Row>
                      <Form.Label column lg={4} className="labelRight">
                        Branch<sup className="required">*</sup>
                      </Form.Label>
                      <Col lg={8}>
                        <Form.Select
                          // name={deptList}
                          onChange={(e) => onSelectBranch(e)}
                          // onChange={(e) => setBranch(e.target.value)}
                          //value={branchList}
                        >
                          <option value="defaultOption">Select Branch</option>
                          {branchList.map(branch => (
                            <option
                              key={branch.id}
                              value={branch.branchName}
                            >
                              {branch.branchName}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (branch == "defaultOption")?
                        <label className="requiredValidation">Please Select Branch </label>:""}
                        {/* {errors.Dept && (
                          <p className="RequiredFields">Please Select Dept</p>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Contract Name<sup className='required'>*</sup></Form.Label>
                      <Col>
                        <Form.Select
                          onChange={(e) => onSelectContractName(e)}
                        >
                        <option value="defaultOption">Select Contract Name</option>
                        {
                        contractList.map(contractName =>
                          (
                           <option key={contractName.id} value={contractName.contractName}>
                           {contractName.contractName}
                        </option>
                        ))}
                        </Form.Select>
                        {error&& (contractName == "defaultOption")?
                        <label className="requiredValidation">Please Select Contract Name </label>:""}
                        {/* {...register("contractName", { required: true, maxLength: 10 })}
                      {errors.contractName && <p className='validationMsg valdiationMsgAlign'>Please Check the Contract Name</p>}
                      </Col>
                    </Row>
                  </Col>  */}
                                {!localStorage.getItem("vendorId") && <Row className='mb-3'>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Vendor
                                                Name<sup className='required'>*</sup></Form.Label>
                                            <Col>
                                                <Form.Select
                                                    aria-label="Default select example subDepartmentList"
                                                    onChange={(e) => onSelectVendorShift(e)}
                                                    // key={result.vendorId}
                                                    // onChange={e => onSelectVendorShift(e, shift.shiftId, shift.shiftName, index)}
                                                    // value={result.vendorId}
                                                >
                                                    <option value={""} key={""}
                                                            id={""}>
                                                        Select Vendor
                                                    </option>
                                                    {vendorList.map((vendor) => (<option
                                                        key={vendor.id}
                                                        value={vendor.id}
                                                        id={vendor.vendorName}
                                                    >
                                                        {vendor.contractName}
                                                    </option>))}
                                                </Form.Select>
                                                  {error && (vendorId.trim().length <= 0)?
                                                  <label className="requiredValidation">Please Select Vendor Name </label>:""}
                                                {/*    {...register("contractorName", { required: true, maxLength: 30 })}*/}
                                                {/*{errors.contractorName && <p className='validationMsg valdiationMsgAlign'>Please Check the Contractor Name</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>}

                                {/* <div class="row">
                    <div class="col-md-8 mx-auto">
                      <h2>Upload Image Example</h2>
                      <p th:text="${message}" th:if="${message ne null}" class="alert alert-primary"></p>
                      <form method="post" enctype="multipart/form-data">
                        <div class="form-group">
                          <input type="file" name="image" accept="image/*" class="form-control-file"/>
                        </div>
                        <button type="submit" class="btn btn-primary">Upload image</button>
                      </form>
                      <span th:if="${msg != null}" th:text="${msg}"></span>
                    </div>
                  </div> */}
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour Name<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourName(e.target.value)}
                                                    value={labourName}
                                                />
                                                {error && labourName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Labour Name Can't be empty
                                                    </label>) : ("")}
                                                {/*{errors.laborerName && <p className='validationMsg valdiationMsgAlign'>Please Check the Laborer Name</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour ID<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourId(e.target.value)}
                                                    value={labourId}
                                                />
                                                {error && labourId.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Labour Id Can't be empty
                                                    </label>) : ("")}
                                                {/*{errors.laborerName && <p className='validationMsg valdiationMsgAlign'>Please Check the Laborer Name</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/*<Col md={6} sm={12} xl={6} lg={6}>*/}
                                    {/*  <Row>*/}
                                    {/*    <Form.Label*/}
                                    {/*        column*/}
                                    {/*        md={4}*/}
                                    {/*        sm={4}*/}
                                    {/*        xl={4}*/}
                                    {/*        lg={4}*/}
                                    {/*        className="labelRight"*/}
                                    {/*    >*/}
                                    {/*      Upload Image<sup className="required">*</sup>*/}
                                    {/*    </Form.Label>*/}

                                    {/*    <Col>*/}
                                    {/*      <Form.Group controlId="formFile" className="mb-3">*/}
                                    {/*        <input*/}
                                    {/*            type="file"*/}
                                    {/*            accept="image/png, image/gif, image/jpeg"*/}
                                    {/*            onChange={(e) => onFileChange(e)}*/}
                                    {/*        />*/}
                                    {/*        {error && fileName.trim().length <= 0 ? (*/}
                                    {/*            <label className="requiredValidation">*/}
                                    {/*              Please Upload an Image*/}
                                    {/*            </label>*/}
                                    {/*        ) : (*/}
                                    {/*            ""*/}
                                    {/*        )}*/}
                                    {/*      </Form.Group>*/}
                                    {/*    </Col>*/}
                                    {/*  </Row>*/}
                                    {/*</Col>*/}
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour DOB<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="date"
                                                    min="1923-01-01"
                                                    max="2010-12-31"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => onSelectDOB(e)}
                                                    value={labourDob}
                                                />
                                                {error && (labourAge <= 18 || labourAge >= 80) ? (
                                                    <label className="requiredValidation">
                                                        Please Select Valid DOB
                                                    </label>) : ("")}
                                                {/* {...register("laborerDob", { required: true, pattern: /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/ })} />
                        {errors.laborerDob && <p className='validationMsg valdiationMsgAlign'>Please Check the Laborer DOB</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labourer Age<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    disabled
                                                    type="text"
                                                    placeholder="Age"
                                                    value={labourAge}
                                                    onChange={(e) => setLabourAge(e.target.value)}
                                                    // {...register("contractorAge", { required: true })}
                                                />
                                                {/* {errors.contractorAge && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Contractor Age Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form.Group as={Row}>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Gender<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col className="mt-2">
                                                <div className="inlineflex">
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            value="male"
                                                            type="radio"
                                                            name="gender"
                                                            aria-label="radio 1"
                                                            label="Male"
                                                            onChange={(e) => setGender(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            value="female"
                                                            type="radio"
                                                            name="gender"
                                                            aria-label="radio 2"
                                                            label="Female"
                                                            onChange={(e) => setGender(e.target.value)}
                                                        />
                                                    </div>
                                                    {/* <div className="mrgnGender">
                            <Form.Check value="other" type="radio" name="gender" aria-label="radio 3" label="Other" onChange={(e) => setGender(e.target.value)} />
                          </div> */}
                                                </div>
                                                {error && gender != "male" && gender != "female" ? (
                                                    <label className="requiredValidation">
                                                        Please Select Gender
                                                    </label>) : ("")}
                                                {/*{errors.gender && <p className='validationMsg valdiationMsgAlign'>Select the Gender</p>}*/}
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form.Group as={Row}>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Migrant Workers<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col className="mt-2">
                                                <div className="inlineflex">
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            value="Yes"
                                                            type="radio"
                                                            name="migrantWorker"
                                                            aria-label="radio 1"
                                                            label="Yes"
                                                            onChange={(e) => setMigrantWorkers(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            value="No"
                                                            type="radio"
                                                            name="migrantWorker"
                                                            aria-label="radio 2"
                                                            label="No"
                                                            onChange={(e) => setMigrantWorkers(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                {error && migrantWorkers != "Yes" && migrantWorkers != "No" ? (
                                                    <label className="requiredValidation">
                                                        Please Select Yes/No
                                                    </label>) : ("")}
                                                {/*{errors.gender && <p className='validationMsg valdiationMsgAlign'>Select the Gender</p>}*/}
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                {" "}
                                                Labour DOJ<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="date"
                                                    placeholder="Enter here.."
                                                    min="1923-01-01"
                                                    onChange={(e) => setLabourDoj(e.target.value)}
                                                    value={labourdoj}
                                                />
                                                {error && labourdoj === "" ? (<label className="requiredValidation">
                                                    Please Select Date
                                                </label>) : ("")}
                                                {/*{...register("doj", { required: true, pattern: /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/ })} />
                        {errors.doj && <p className='validationMsg valdiationMsgAlign'>Please Check the DOJ</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Labour Blood Group<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setLabourBloodGroup(e.target.value)}
                                                    value={labourBloodGroup}
                                                />
                                                {error && labourBloodGroup.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Blood group
                                                    </label>) : ("")}
                                                {/*{...register("laborerAge", { required: true })} />
                        {errors.laborerAge && <p className='validationMsg valdiationMsgAlign'>Laborer Age Required</p>}*/}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Designation<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setDesignation(e.target.value)}
                                                    value={designation}
                                                />
                                                {error && designation.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Designation
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Educational Qualification
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setEducationalQualification(e.target.value)}
                                                    value={educationalQualification}
                                                />
                                                {error && educationalQualification.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Educational Qualification
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Aadhar No<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAadharNo(e.target.value)}
                                                    value={aadharNo}
                                                />
                                                {error && aadharNo.trim().length != 12 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Aadhar Number
                                                    </label>) : ("")}
                                                {unique === true ?
                                                    <label className="requiredValidation">
                                                        Aadhar Number already exists
                                                    </label> : ("")
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Fixed Manpower or variable Manpower
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setManpower(e.target.value)}
                                                    value={manpower}
                                                />
                                                {error && manpower.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Address
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                          <textarea
                              className="form-control"
                              type="text"
                              placeholder="Enter here.."
                              onChange={(e) => setAddress(e.target.value)}
                              value={address}
                          />
                                                {error && address.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Address
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">
                                                Pincode
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setPinCode(e.target.value)}
                                                    value={pinCode}
                                                />
                                                {error && pinCode.length != 6 ? (<label className="requiredValidation">
                                                    Please Enter Valid Pincode
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contact Number
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setContactNumber(e.target.value)}
                                                    value={contactNumber}
                                                />
                                                {error && contactNumber.length != 10 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Contact Number
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Alternative Number
                                                {/* <sup className='required'>*</sup> */}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAltNumber(e.target.value)}
                                                    value={altNumber}
                                                />
                                                {error && altNumber === contactNumber && contactNumber.length === 10 ? (
                                                    <label className="requiredValidation">
                                                        This Number was already Provided in "Contact
                                                        Number", Please Enter New Number or Make it empty.
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Email Id
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                                {error && email.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Valid Email Id
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Alternative Email Id
                                                {/* <sup className='required'>*</sup> */}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setAltEmail(e.target.value)}
                                                    value={altEmail}
                                                />
                                                {error && altEmail === email && email.length !== 0 ? (
                                                    <label className="requiredValidation">
                                                        This Id was already Provided in "Email Id", Please
                                                        enter another Id or make it empty.{" "}
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Bank State
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBankState(e.target.value)}
                                                    value={bankState}
                                                />
                                                {error && bankState.length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Bank State
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Bank Name
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBankName(e.target.value)}
                                                    value={bankName}
                                                />
                                                {error && bankName.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Bank Name
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Account Number
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAccountNo(e.target.value)}
                                                    value={accountNo}
                                                />
                                                {error && (accountNo.length < 5 || accountNo.length > 18) ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Account Number
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                IFSC Code
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setIfscCode(e.target.value)}
                                                    value={ifscCode}
                                                />
                                                {error && ifscCode.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter IFSC Code{" "}
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Branch Name
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBranchName(e.target.value)}
                                                    value={branchName}
                                                />
                                                {error && branchName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Branch Name{" "}
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/* <Col md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Mail Id<sup className='required'>*</sup></Form.Label>
                      <Col>
                        <Form.Control
                          type="email"
                          placeholder="name@example.com"
                          onChange={(e) => setMailId(e.target.value)}
                          value={mailId} />
                      </Col>
                    </Row>
                  </Col> */}
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                ESI NO
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setEsiNo(e.target.value)}
                                                    value={esiNo}
                                                />
                                                {error && esiNo.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Esi No.{" "}
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                PF Establishment Number
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setPfEstNo(e.target.value)}
                                                    value={pfEstNo}
                                                />
                                                {error && pfEstNo.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter PF Est No.
                                                    </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                UAN NO
                                                {/*<sup className="required">*</sup>*/}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setUanNo(e.target.value.replace(/\D/g, ""))}
                                                    value={uanNo}
                                                />
                                                {error && uanNo.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter UAN No.{" "}
                                                </label>) : ("")}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={6} xs={6} lg={6}>
                                        <Row>
                                            <div className="SaveCancelButtonDiv">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="text-right">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={uploadDocshandleShow}
                                                            >
                                                                Upload Documents
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={6} xs={6} lg={6}>
                                        <Row>
                                            <div className="SaveCancelButtonDiv">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="text-right">
                                                            {/* <button type="button" className="btn btn-primary float-end mx-2">Cancel</button> */}
                                                            <button
                                                                type="button"
                                                                className="btn btn-success float-end"
                                                                onClick={(e) => errorCheck(e)}
                                                            >
                                                                Proceed
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Form>
                </div>
            </div>
        </Container>
        <Modal
            show={showUploadDocsModal}
            onHide={uploadDocshandleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Upload Documents</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <Row>
                            <Form.Label column md={4} className="labelRight">
                                Labour Photo
                            </Form.Label>
                            <Col>
                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Control
                                        type="file"
                                        onChange={onFileChange}
                                        accept="image/png, image/jpeg"
                                    />
                                    <Form.Text className="text-muted">
                                        Allowed: PNG, JPEG
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <Row>
                            <Form.Label column md={4} className="labelRight">
                                Aadhaar Card
                            </Form.Label>
                            <Col>
                                <Form.Group controlId="formFileAadhaar" className="mb-3">
                                    <Form.Control
                                        type="file"
                                        onChange={onAadhaarFileChange}
                                        accept="application/pdf, image/png, image/jpeg"
                                    />
                                    <Form.Text className="text-muted">
                                        Allowed: PDF, PNG, JPEG
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <Row>
                            <Form.Label column md={4} className="labelRight">
                                E-Pehchan Card
                            </Form.Label>
                            <Col>
                                <Form.Group controlId="formFileEPehchan" className="mb-3">
                                    <Form.Control
                                        type="file"
                                        onChange={onEPehchanFileChange}
                                        accept="application/pdf, image/png, image/jpeg"
                                    />
                                    <Form.Text className="text-muted">
                                        Allowed: PDF, PNG, JPEG
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={uploadDocshandleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={uploadDocuments}>
                    Save & Upload
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={showL}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="modal-header">
                <Modal.Title>Confirm Proceed</Modal.Title>
            </Modal.Header>
            {showMsgL == "" && (<Modal.Body>Please click on "Proceed" to Proceed.</Modal.Body>)}
            {showMsgL != "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                <h5>Labour details added Successfully !!</h5>
            </Modal.Body>)}
            <Modal.Footer>
                {showMsgL == "" && (<Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>)}
                {showMsgL != "" && (<Button variant="secondary" onClick={(e) => handleBack(e)}>
                    Back
                </Button>)}
                {showMsgL == "" && (<Button
                    type="button"
                    variant="primary"
                    onClick={(e) => handleSubmit(e)}
                >
                    Proceed
                </Button>)}
            </Modal.Footer>
        </Modal>
    </div>);
}

export default LaborerMaster;
